import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { GameSmall } from '../Game/GameSmall.jsx'

export class HorizontalItems extends React.Component {
    constructor(props) {
        super(props);

        this.autoScrool = this.autoScrool.bind(this);
        this.currPage = 1;
        this.container = React.createRef();
        
    };

    componentDidMount = () => {
        this.container.current.addEventListener('touchend', this.touchEndEvent, false);
        this.container.current.addEventListener('touchstart', this.touchStartEvent, false);

        if (this.props.autoScrool)
            this.autoScroolTimer = setInterval(this.autoScrool, 7000);
    };

    componentWillUnmount = () => {
        this.container.current.removeEventListener('touchend', this.touchEndEvent);
        this.container.current.removeEventListener('touchstart', this.touchStartEvent);

        this.resetAllTimers();
        clearInterval(this.autoScroolTimer);
    };



    touchStartEvent = () => {
        this.resetAllTimers(true);
        clearInterval(this.autoScroolTimer);

        // idemo pratit dali smo promjenili page
        const element = this.container.current;
        const computedStyleLastElement = window.getComputedStyle(element.lastChild);
        const elementWidth = casino.utils.pxToNumber(computedStyleLastElement.width);
        const leftMargin = casino.utils.pxToNumber(computedStyleLastElement.marginLeft);

        this.lastPage = 0;
        this.navigationRefresher = setInterval(() => {
            var part = element.scrollLeft / (leftMargin + elementWidth);
            var partRounded = Math.round(part);

            var page = Math.floor(partRounded / 2) + 1;

            if (this.props.items.length == (partRounded + 2))
                var page = Math.ceil(partRounded / 2) + 1;
            if (page != this.lastPage) {
                this.lastPage = page;
                this.selectPage(page);
            }
        }, 45)

    }

    touchEndEvent = () => {
        this.resetAllTimers(false);

        // moramo saznati kada možemo krenuti u računanje fiksne pozicije
        this.touchEndTriggered = setTimeout(() => {
            const element = this.container.current;
            var left = element.scrollLeft;

            this.checkScroolEnd = setInterval(() => {
                if (left != element.scrollLeft) {
                    left = element.scrollLeft;
                }
                else {
                    clearInterval(this.checkScroolEnd);
                    this.touchEnd();
                }
            }, 100)
        }, 650);
    }


    touchEnd = () => {
        clearInterval(this.navigationRefresher);

        const element = this.container.current;

        const computedStyleLastElement = window.getComputedStyle(element.lastChild);
        const elementWidth = casino.utils.pxToNumber(computedStyleLastElement.width);
        const leftMargin = casino.utils.pxToNumber(computedStyleLastElement.marginLeft);

        var part = element.scrollLeft / (leftMargin + elementWidth);
        var partRounded = Math.round(part);

        this.goLeft(partRounded * (leftMargin + elementWidth));

        var page = Math.floor(partRounded / 2) + 1;

        if (this.props.items.length == (partRounded + 2))
            var page = Math.ceil(partRounded / 2) + 1;

        this.selectPage(page);
    }



    goLeft = (width) => {
        // ajde lijepo dođi na fiksnu poziciju
        const element = this.container.current;
        let current = element.scrollLeft;
        window.cancelAnimationFrame(this.animationNumber);
        this.animationNumber = window.requestAnimationFrame(() => this.doStep(element, current, width, Math.abs(width - current) / 20));
    }

    doStep = (element, current, width, speed) => {
        // polako idmeo na određenu poziciju
        if (current < width) {
            current += speed;
            element.scrollLeft = current;
        } else if (current > width) {
            current -= speed;
            element.scrollLeft = current;
        }

        if (Math.abs(current - width) < speed) {
            element.scrollLeft = width;
        }
        else {
            this.animationNumber = window.requestAnimationFrame(() => this.doStep(element, current, width, speed));
        }
    };



    changePageClick = (i) => {
        this.resetAllTimers();

        const element = this.container.current;

        const computedStyleLastElement = window.getComputedStyle(element.lastChild);
        const elementWidth = casino.utils.pxToNumber(computedStyleLastElement.width);
        const leftMargin = casino.utils.pxToNumber(computedStyleLastElement.marginLeft);
        this.goLeft((i - 1) * 2 * (leftMargin + elementWidth));

        this.selectPage(i);
    }


    selectPage = (page) => {

        this.currPage = page;

        if (this.props.hideNavigation)
            return;

        if (page < 1 || !this.props.items) // ios fore, u minus
            return;

        for (let i = 1; i <= Math.ceil(this.props.items.length / 2); i++) {
            let className = "icon" + (i == page ? " ico-circle-fill-8" : " ico-circle-outline-8");
            this["btn" + i].current.className = className; 
        }
    }


    resetAllTimers = (navigationRefresherTo = true) => {
        clearTimeout(this.touchEndTriggered);
        clearInterval(this.checkScroolEnd);
        window.cancelAnimationFrame(this.animationNumber);

        if (navigationRefresherTo)
            clearInterval(this.navigationRefresher);
    }

    renderButtons = () => {
        var rows = [];
        for (let i = 1; i <= Math.ceil(this.props.items.length / 2); i++) {
            let className = "icon" + (i == 1 ? " ico-circle-fill-8" : " ico-circle-outline-8");
            rows.push(<span key={i} className={className} onClick={() => this.changePageClick(i)} ref={this["btn" + i]}></span>);
        }
        return <div>{rows}</div>
    }

    autoScrool() {
        var currPage = this.currPage;
        var maxPage = Math.ceil(this.props.items.length / 2);
        var newPage = (currPage + 1) % maxPage;
        this.changePageClick(newPage);

        if (newPage == 1)
            clearInterval(this.autoScroolTimer);
    }




    render() {
        
        if (this.props.items) {
            for (let i = 1; i <= Math.ceil(this.props.items.length / 2); i++) {
                this["btn" + i] = React.createRef();
            }
        }
        return <div className='horizontal-items margin-bottom-small'>
            <div className='horizontal-items--container clearfix' ref={this.container} style={{ marginBottom: (this.props.hideNavigation ? '-3rem' : 'auto') }}>

                {!this.props.items && <div>Dohvaćanje podataka...<br /><br /></div>}

                {/*  poker turniri */}
                {this.props.items && !this.props.jackpotGamesWin && this.props.items.map((x) =>
                    <div key={x.sifra}>
                        <NavLink to={x.url} >
                            {x.soonBadge && <div className="soon-badge small"></div>}
                            <img src={x.bannerUrl} />
                            <span>{x.naziv}</span>
                        </NavLink>
                        <div className='margin-bottom'> </div>
                    </div>)
                }

                {/*  casino dobitci */}
                {this.props.items && this.props.jackpotGamesWin && this.props.items.map((x, index) => {
                    var game = this.props.igre.filter(y => y.s == x.igraSifra);
                    if (game.length == 1) {
                        return <div key={x.id} className="margin-bottom-xl">
                            <GameSmall
                                categories={this.props.categories}
                                routePrefix={this.props.routePrefix}
                                from={this.props.from}
                                igra={game[0]}
                                extraClass={""} {...x}
                                brands={this.props.brands}
                                // GamePosition podaci, HizmanB
                                PageName={this.props.PageName}
                                GamePosition={index + 1}
                                PositionType={this.props.PositionType}
                                ComponentName={"najveci-jackpot-dobitnici"}
                                ComponentPosition={index + 1}
                                IsIcon={false}
                                TabName={this.props.TabName}
                            />
                        </div>
                    }
                })}

            </div>
            {this.props.items && !this.props.hideNavigation &&
                <div className='horizontal-items--navigation'>
                    {this.renderButtons()}
                </div>}

        </div>

    }
}